import React, { useState, useEffect } from 'react';
import './GiseMaskot.css';

// Görsel → ekran eşleştirmesi
// Görselleri /public/gise/ klasörüne koyun
const GORSEL_MAP = {
  'home':             '/gise/04_hosgeldiniz.png',
  'event-select':     '/gise/01_gise_kabini.png',
  'seat-select':      '/gise/02_bilet_tutan.png',
  'checkout':         '/gise/03_masa_arkasi.png',
  'tickets':          '/gise/05_goz_kirpma.png',
  'admin-panel':      '/gise/07_rozet_tutan.png',
  'event-management': '/gise/06_patlamis_misir.png',
  'manage-codes':     '/gise/07_rozet_tutan.png',
  'event-creator':    '/gise/03_masa_arkasi.png',
  'venue-manage':     '/gise/03_masa_arkasi.png',
  'qr-scanner':       '/gise/05_goz_kirpma.png',
};

const VARSAYILAN = '/gise/04_hosgeldiniz.png';

const GiseMaskot = ({ currentView }) => {
  const [gorsel, setGorsel] = useState(VARSAYILAN);
  const [animating, setAnimating] = useState(false);
  const [gizli, setGizli] = useState(false);

  useEffect(() => {
    const yeniGorsel = GORSEL_MAP[currentView] || VARSAYILAN;

    if (yeniGorsel !== gorsel) {
      // Geçiş animasyonu
      setAnimating(true);
      const t = setTimeout(() => {
        setGorsel(yeniGorsel);
        setAnimating(false);
      }, 200);
      return () => clearTimeout(t);
    }
  }, [currentView]);

  if (gizli) {
    return (
      <button
        className="maskot-goster-btn"
        onClick={() => setGizli(false)}
        title="Gişe Görevlisini Göster"
      >
        🧑‍💼
      </button>
    );
  }

  return (
    <div className={`maskot-container ${animating ? 'maskot-fade-out' : 'maskot-fade-in'}`}>
      <button
        className="maskot-gizle-btn"
        onClick={() => setGizli(true)}
        title="Gizle"
      >
        ✕
      </button>
      <img
        src={gorsel}
        alt="Gişe Görevlisi"
        className="maskot-img"
        onError={(e) => { e.target.style.display = 'none'; }}
      />
    </div>
  );
};

export default GiseMaskot;
